import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
} from 'reactstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_Web_RTC,
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
let arr = [];
export default function WebRTCIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({
    sipUrl: '',
    sipPassword: '',
  });
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    sipUrl: '',
    sipPassword: '',
    webSocketUrl: '',
    viaTransport: '',
    webRTCApplication: 'DigitalCompendium',
  });


  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_Web_RTC}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setInputData({
            ...inputData,
            Name: res.data.name,
            Properties:
              res.data.properties !== null ? [res.data.properties[0]] : [],
            sipUrl: res.data.webRTCIntegration?.sipUrl,
            sipPassword: res.data.webRTCIntegration?.sipPassword,
            webSocketUrl: res.data.webRTCIntegration?.webSocketUrl,
            viaTransport: res.data.webRTCIntegration?.viaTransport,
            webRTCApplication: res.data.webRTCIntegration?.webRTCApplication,
            activeChats: res.data.webRTCIntegration?.activeChats,
            agentAssist: res.data.webRTCIntegration?.agentAssist
          });

          setMaskData({
            ...maskData,
            sipPassword: mask(res.data.webRTCIntegration?.sipPassword),
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };



  const handleTransportChange = (e) => {
    e.persist();
    setInputData({ ...inputData, viaTransport: e.target.value });
  };



  const handlesipUrlChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, sipUrl: mask(e.target.value) });
    setInputData({ ...inputData, sipUrl: e.target.value });
  };
  const handlesipPasswordChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, sipPassword: mask(e.target.value) });
    setInputData({ ...inputData, sipPassword: e.target.value });
  };
  const handlewebSocketUrlChange = (e) => {
    e.persist();
    setInputData({ ...inputData, webSocketUrl: e.target.value });
  };
  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, Properties: [e.target.value] });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, Properties: [] });
    }
  };

  const handleSave = async () => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${API_Web_RTC}/${id}?group_id=${getGroupID()}`,
        data: inputData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            //window.location.reload();
          }, 300);
        }
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: API_Web_RTC,
        data: inputData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            // window.location.reload();
          }, 300);
        }
      });
    }
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? 'Add' : 'Update'} Integration</h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>SIP Url</Label>
                    <Input
                      type="text"
                      name="sipUrl"
                      onChange={handlesipUrlChange}
                      placeholder="SIP Url"
                      defaultValue={inputData
                        .sipUrl}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>SIP Password</Label>
                    <Input
                      type="text"
                      name="sipPassword"
                      onChange={handlesipPasswordChange}
                      placeholder="SIP Password"
                      defaultValue={maskData.sipPassword}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>WebSocket Url</Label>
                    <Input
                      type="text"
                      name="webSocketUrl"
                      onChange={handlewebSocketUrlChange}
                      placeholder="WebSocket Url"
                      defaultValue={inputData.webSocketUrl}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Via Transport</Label>
                    <Input
                      type="text"
                      name="viaTransport"
                      onChange={handleTransportChange}
                      placeholder="Via Transport"
                      defaultValue={inputData.viaTransport}
                    />
                  </FormGroup>
                  <h6>Choose Applications to activate the feature</h6>
                  <FormGroup className="mb-1">
                    <div className="">
                      <Input
                        type="select"
                        name="webRTCApplication"
                        onChange={(e) => setInputData({ ...inputData, webRTCApplication: e.target.value })}
                        value={inputData.webRTCApplication}
                      >
                        <option value={"DigitalCompendium"}>Digital Compendium</option>
                        <option value={"AgentAssist"}>Agent Assist</option>
                      </Input>
                    </div>
                  </FormGroup>
                  {/* <FormGroup className="mb-1">
                    <div className="">
                      <CustomInput
                        key={'activeChats'}
                        type="checkbox"
                        label={'Active Chats'}
                        name="activeChats"
                        checked={inputData.activeChats}
                        onChange={(e) => setInputData({ ...inputData, activeChats: e.target.checked })}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-1">
                    <div className="">
                      <CustomInput
                        key={'agentAssist'}
                        type="checkbox"
                        label={'Agent Assist'}
                        name="showRatesSelectedRoom"
                        checked={inputData.agentAssist}
                        onChange={(e) => setInputData({ ...inputData, agentAssist: e.target.checked })}
                      />
                    </div>
                  </FormGroup> */}
                  <h6 className='my-2'>Choose Business</h6>

                  <FormGroup className="mb-2">
                    <div className="integration-property mt-0">
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.Properties[0] ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
